import qs from 'qs';
import { Util } from '@microsoft/applicationinsights-web' 

export default function getCorrelationId() {
    var queryParameters = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
        decoder: decodeURIComponent
    });

    let correlation_id = Util.generateW3CId();
    if (queryParameters.correlation_id != null) { 
        var sanitized_correlation_id = sanitizedCorrelationId(queryParameters, correlation_id);
        if (isValidW3CTraceId(sanitized_correlation_id)) {
            correlation_id = sanitized_correlation_id;
        }
    }
    return correlation_id;
};

function sanitizedCorrelationId(queryParameters: any, correlation_id: string) { 
    let corrId: string = queryParameters.correlation_id;
    if (corrId != null) {
        if (corrId.includes('|')) {
            corrId = corrId.replace('|', '');
        }
        if (corrId.includes('-')) {
            corrId = corrId.replace('-', '');
        }
        correlation_id = corrId.split('.')[0];
        
    }
    return correlation_id;
}

function isValidW3CTraceId(trace_id: string): boolean {
    var regEx = new RegExp('^[\\da-f]{32}$');
    return regEx.test(trace_id);
}